import { ACTIONS } from '../Constants';

const checkMobile = () => window.innerWidth < 992;
export const isMobile = () => (dispatch) => {
    // let isMobile = true;
    if (checkMobile()) {
        dispatch({
            type: ACTIONS.SET_MOBILE_STATUS,
            payload: {
                isMobile: true
            }
        });
    }
};
